<template>
  <div>
    <div class="comm_popup_wrap_xlarge">
      <div class="comm_ptitle_wrap">
        <h1>{{ $t('MSG_TXT_DEFAULT_INFO') }}</h1>
      </div>
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_SITE_ABBR')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-text-field
              v-model="frame1.siteName"
              :disabled="true"
              :readonly="false"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_DSRT_NM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-text-field
              v-model="frame1.jobDistrictName"
              :disabled="true"
              :readonly="false"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_GEHS_LOC_ID')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-text-field
              v-model="frame3.locationId"
              :disabled="true"
              :readonly="false"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_BUIL_NM')"
              :vertical="true"
            />
          </div>
          <div class="col-xs-3">
            <sui-text-field
              v-model="frame3.locationName"
              :disabled="true"
              :readonly="false"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_BUIL_EN_NM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-text-field
              v-model="frame3.locationEnglishName"
              :disabled="true"
              :readonly="false"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_HDQT_BUIL_ID')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-text-field
              v-model="headquarterBuildingId"
              :disabled="true"
              :readonly="false"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_BUIL_TYPE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-code-select
              ref="buildingTypeCode"
              :selected="frame1.selectedCode.COD_BUIL_TYPE"
              codeId="COD_BUIL_TYPE"
              :disabled="true"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_BUIL_USE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-code-select
              ref="buildingUseCode"
              :selected="frame1.selectedCode.COD_BUIL_UE"
              codeId="COD_BUIL_UE"
              :disabled="true"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_BIZ_SECT_DIV')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-code-select
              ref="businessSectorDivisionCode"
              :selected="frame1.selectedCode.COD_BIZ_SECT_DIV"
              codeId="COD_BIZ_SECT_DIV"
              :disabled="true"
            />
          </div>
        </div>
        <div class="mrB30" />
        <div class="comm_ptitle_wrap">
          <h1>{{ $t('MSG_TXT_FLOR_INFO') }}</h1>
        </div>
        <div class="comm_view_wrap">
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_FLOR_NM')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <sui-text-field
                ref="locationName"
                v-model="frame0.locationName"
                :disabled="false"
                :readonly="false"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_FLOR_EN_NM')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <sui-text-field
                ref="locationEnglishName"
                v-model="frame0.locationEnglishName"
                :disabled="false"
                :readonly="false"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_GEHS_LOC_ID')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <sui-text-field
                v-model="frame0.locationId"
                :disabled="true"
                :readonly="false"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_MDFC_USR')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <cmp-user-name-link
                :pageId="pageId"
                :displayType="'1'"
                :displayLanguageId="frame0.displayLanguageId"
                :knoxId="frame0.knoxId"
                :userName="frame0.userName"
                :userGlobalName="frame0.userGlobalName"
                :departmentName="frame0.departmentName"
                :departmentEnglishName="frame0.departmentEnglishName"
                :type="'link'"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_MDFC_DTM')"
                :vertical="true"
              />
            </div>
            <div class="col-xs-3">
              <sui-text-field
                v-model="frame0.finalModificationDTM"
                :disabled="true"
                :readonly="false"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_HDQT_LOC_ID')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <sui-text-field
                v-model="frame0.headquarterLocationId"
                :disabled="true"
                :readonly="false"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_MDM_MDFC_USR')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <cmp-user-name-link
                :pageId="pageId"
                :displayType="'1'"
                :displayLanguageId="frame2.displayLanguageId"
                :knoxId="frame2.knoxId"
                :userName="frame2.userName"
                :userGlobalName="frame2.userGlobalName"
                :departmentName="frame2.departmentName"
                :departmentEnglishName="frame2.departmentEnglishName"
                :type="'link'"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_MDM_MDFC_DT')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <sui-text-field
                v-model="frame2.finalModificationDTM"
                :disabled="true"
                :readonly="false"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_HDQT_FLOR_CODE')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <sui-text-field
                v-model="frame2.headquarterFloorId"
                :disabled="true"
                :readonly="false"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_USE_YN')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <sui-radio
                v-model="frame0.selectedCode.COD_USE_YN.key"
                value="Y"
              >
                Yes
              </sui-radio>
              <sui-radio
                v-model="frame0.selectedCode.COD_USE_YN.key"
                value="N"
              >
                No
              </sui-radio>
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_ARRAY_ORDER')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <sui-text-field
                ref="arrayalOrder"
                v-model="frame0.arrayalOrder"
                :disabled="false"
                :readonly="false"
                mask="number"
                maxlength="4"
              />
            </div>
            <div class="col-xs-1 nodata" />
            <div class="col-xs-3" />
          </div>
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_DTL_INFO')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-11">
              <textarea
                v-model="frame0.locationNoteContent"
                maxlength="1000"
              />
            </div>
          </div>
        </div>
        <div class="mrB30" />
        <div class="comm_ptitle_wrap">
          <h1>{{ $t('MSG_TXT_DTL_LOC_INFO') }}</h1>
        </div>
        <div class="comm_view_wrap">
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_GIS_X_CODN_START')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <sui-text-field
                ref="gisXStartValue"
                v-model="frame2.gisXStartValue"
                mask="decimal"
                maxlength="30"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_GIS_X_CODN_END')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <sui-text-field
                ref="gisXFinishValue"
                v-model="frame2.gisXFinishValue"
                mask="decimal"
                maxlength="30"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_GIS_LAYER_NO')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <sui-text-field
                ref="gisLayerNumber"
                v-model="frame2.gisLayerNumber"
                mask="number"
                maxlength="100"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_GIS_Y_CODN_START')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <sui-text-field
                ref="gisYStartValue"
                v-model="frame2.gisYStartValue"
                mask="decimal"
                maxlength="30"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_GIS_Y_CODN_END')"
                :vertical="true"
              />
            </div>
            <div class="col-xs-3">
              <sui-text-field
                ref="gisYFinishValue"
                v-model="frame2.gisYFinishValue"
                mask="decimal"
                maxlength="30"
              />
            </div>
            <div class="col-xs-1 nodata" />
            <div class="col-xs-3" />
          </div>
        </div>
      </div>
    </div>
    <div class="comm_btn_wrap mrR30">
      <sui-button
        type="button"
        class="comm_btn_border"
        @click="onClickClose"
      >
        {{ $t('MSG_BTN_CANCEL') }}
      </sui-button>
      <sui-button
        v-permission:update="pageId"
        type="button"
        class="comm_btn_solid"
        @click="onClickSave"
      >
        {{ $t('MSG_BTN_SAVE') }}
      </sui-button>
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line import/no-unresolved
import BasePage from '~cm/components/BasePage';

const dateFields = [
  'firstRegistrationDTM', 'finalModificationDTM', 'pageUsePriodStartDatetime', 'pageUsePriodFinishDatetime',
];
export default {
  name: 'PGE_CMY_00007_P06', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    selectedData: {
      type: Object,
      default: null,
    },
    pageId: {
      type: String,
      default: null,
    },
    siteId: {
      type: String,
      default: null,
    },
    headquarterBuildingId: {
      type: String,
      default: null,
    },
    buildingId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      frame0: {
        selectedCode: {
          COD_USE_YN: {
            key: '',
            label: '',
          },
        },
        locationId: '',
        locationName: '',
        locationEnglishName: '',
        arrayalOrder: '',
        finalModificationDTM: '',
        finalModificationUserId: '',
        locationNoteContent: '',
        headquarterLocationId: '',
        knoxId: '',
        userName: '',
        userGlobalName: '',
        departmentName: '',
        departmentEnglishName: '',
        displayLanguageId: '',
      },
      frame1: {
        selectedCode: {
          COD_BUIL_TYPE: {
            key: '',
            label: '',
          },
          COD_BUIL_UE: {
            key: '',
            label: '',
          },
          COD_BIZ_SECT_DIV: {
            key: '',
            label: '',
          },
        },
        siteName: '',
        jobDistrictName: '',
        locationId: '',
        locationName: '',
        locationEnglishName: '',
        headquarterBuildingId: '',
        headquarterLocationId: '',
      },
      frame3: {
        locationId: '',
        locationName: '',
        locationEnglishName: '',
      },
      frame2: {
        gisXStartValue: '',
        gisXFinishValue: '',
        gisYStartValue: '',
        gisYFinishValue: '',
        gisLayerNumber: '',
        headquarterFloorId: '',
        finalModificationDTM: '',
        finalModificationUserId: '',
        knoxId: '',
        userName: '',
        userGlobalName: '',
        departmentName: '',
        departmentEnglishName: '',
        displayLanguageId: '',
      },
    };
  },
  computed: {},
  watch: {},
  datasets: [],
  mounted() {
    this.setData();
    this.setBuildingInfo();
    this.setHeadquarterBuildingInfo();
    this.setFloorInfo();
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    /**
     *  층 정보 SET
     */
    setData() {
      utils.forEach(this.frame0, (value, key) => {
        if (utils.isEqual(key, 'selectedCode')) {
          this.frame0.selectedCode.COD_USE_YN.key = this.selectedData.locationUseYn;
        } else if (utils.isEqual(key, 'arrayalOrder')) {
          // text field mask="number" 사용 시 타입이 int인 경우 버그 발생
          // 해결을 위한 문자타입으로 변환.
          this.frame0[key] = this.selectedData[key].toString();
        } else {
          this.frame0[key] = this.selectedData[key];
        }
      });
    },
    /**
     *  건물 정보 SET
     */
    setBuildingInfo() {
      const queryParams = {
        siteId: '',
        jobDistrictId: '',
        buildingId: '',
        locationUseYn: '',
        locationEnglishName: '',
        locationName: '',
        locationId: this.buildingId,
      };

      http.request(this.pageId, 'DTS_CMY_00030', {
        query: queryParams,
      }).then(res => {
        utils.forEach(this.frame3, (value, key) => {
          this.frame3[key] = res.data[0][key];
        });
      });
    },
    /**
     *  전사 건물 정보 SET
     */
    setHeadquarterBuildingInfo() {
      const queryParams = {
        headquarterSiteId: '',
        headquarterJobDistrictId: '',
        headquarterBuildingName: '',
        headquarterBuildingEnglishName: '',
        buildingTypeCode: '',
        buildingUseCode: '',
        gehsRegistrationYn: '',
        headquarterBuildingId: this.headquarterBuildingId,
        siteId: '',
      };

      http.request(this.pageId, 'DTS_CMY_00033', {
        query: queryParams,
      }).then(res => {
        utils.dateformatToClientInArray(res.data, dateFields);
        if (res.data.length > 0) {
          utils.forEach(this.frame1, (value, key) => {
            if (utils.isEqual(key, 'selectedCode')) {
              this.frame1.selectedCode.COD_BUIL_TYPE.key = res.data[0].buildingTypeCode;
              this.frame1.selectedCode.COD_BUIL_UE.key = res.data[0].buildingUseCode;
              this.frame1.selectedCode.COD_BIZ_SECT_DIV.key = res.data[0].businessSectorDivisionCode;
            } else {
              this.frame1[key] = res.data[0][key];
            }
          });
        }
      });
    },
    /**
     *  전사 층 정보 SET
     */
    setFloorInfo() {
      const queryParams = {
        headquarterSiteId: '',
        headquarterJobDistrictId: '',
        headquarterBuildingId: '',
        gehsRegistrationYn: '',
        headquarterFloorId: this.selectedData.headquarterLocationId,
        siteId: this.siteId,
      };

      http.request(this.pageId, 'DTS_CMY_00034', {
        query: queryParams,
      }).then(res => {
        utils.dateformatToClientInArray(res.data, dateFields);

        if (res.data.length > 0) {
          utils.forEach(this.frame2, (value, key) => {
            if (utils.isEqual(key, 'gisLayerNumber')) {
              // text field mask="number" 사용 시 타입이 int인 경우 버그 발생
              // 해결을 위한 문자타입으로 변환.
              this.frame2[key] = res.data[0][key].toString();
            } else {
              this.frame2[key] = res.data[0][key];
            }
          });
        }
      });
    },
    /**
     *  취소
     */
    onClickClose() {
      this.$emit('closePopup');
    },
    /**
     *  저장
     */
    onClickSave() {
      const dataParams = {
        locationId: this.frame0.locationId,
        locationName: this.frame0.locationName,
        locationEnglishName: this.frame0.locationEnglishName,
        arrayalOrder: this.frame0.arrayalOrder,
        locationNoteContent: this.frame0.locationNoteContent,
        locationUseYn: this.frame0.selectedCode.COD_USE_YN.key,
        headquarterFloorId: this.frame0.headquarterLocationId,
        gisXStartValue: this.frame2.gisXStartValue,
        gisXFinishValue: this.frame2.gisXFinishValue,
        gisYStartValue: this.frame2.gisYStartValue,
        gisYFinishValue: this.frame2.gisYFinishValue,
        gisLayerNumber: this.frame2.gisLayerNumber,
      };

      if (!this.validCheck()) return false;

      utils.messageBox('confirm', this.$t('MSG_ALT_WANT_SAVE'), null, () => {
        http.request(this.pageId, 'DTS_CMY_00038', {
          data: dataParams,
        }).then(() => {
          utils.messageBox('success', this.$t('MSG_ALT_SAVE_DATA'), null, () => {
            this.$emit('closePopup');
            this.$emit('onClickSearch');
            this.$emit('setSelectBox');
          });
        });
      });

      return null;
    },
    /**
     *  입력 체크
     */
    validCheck() {
      // if (utils.isEmpty(utils.trim(this.frame0.locationName))) {
      //   utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_FLOR_NM')),
      //     null, () => {
      //       this.$refs.locationName.setFocus();
      //     });
      //   return false;
      // }
      // if (utils.isEmpty(utils.trim(this.frame0.locationEnglishName))) {
      //   utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_FLOR_EN_NM')),
      //     null, () => {
      //       this.$refs.locationEnglishName.setFocus();
      //     });
      //   return false;
      // }
      if (utils.isEmpty(utils.trim(this.frame0.selectedCode.COD_USE_YN.key))) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_USE_YN')));
        return false;
      }
      // if (utils.isEmpty(utils.trim(this.frame0.arrayalOrder))) {
      //   utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_ARRAY_ORDER')),
      //     null, () => {
      //       this.$refs.arrayalOrder.setFocus();
      //     });
      //   return false;
      // }
      // if (utils.isEmpty(utils.trim(this.frame2.gisXStartValue))) {
      //   utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_GIS_X_CODN_START')),
      //     null, () => {
      //       this.$refs.gisXStartValue.setFocus();
      //     });
      //   return false;
      // }
      // if (utils.isEmpty(utils.trim(this.frame2.gisXFinishValue))) {
      //   utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_GIS_X_CODN_END')),
      //     null, () => {
      //       this.$refs.gisXFinishValue.setFocus();
      //     });
      //   return false;
      // }
      // if (utils.isEmpty(utils.trim(this.frame2.gisLayerNumber))) {
      //   utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_GIS_LAYER_NO')),
      //     null, () => {
      //       this.$refs.gisLayerNumber.setFocus();
      //     });
      //   return false;
      // }
      // if (utils.isEmpty(utils.trim(this.frame2.gisYStartValue))) {
      //   utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_GIS_Y_CODN_START')),
      //     null, () => {
      //       this.$refs.gisYStartValue.setFocus();
      //     });
      //   return false;
      // }
      // if (utils.isEmpty(utils.trim(this.frame2.gisYFinishValue))) {
      //   utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_GIS_Y_CODN_END')),
      //     null, () => {
      //       this.$refs.gisYFinishValue.setFocus();
      //     });
      //   return false;
      // }
      return true;
    },
  },
};
</script>
<style scoped>
</style>
